import { BrowseSkills } from "@/pages/migrations/BrowseSkills";
import { ToolsPage } from "@/pages/tools";
import { TemplateWorkspace } from "@/pages/migrations/TemplateWorkspace";
import { SkillRun } from "@/pages/migrations/SkillRun";
import { AgentsList } from "@/pages/agents/AgentsList";
import { AgentCreate } from "@/pages/agents/AgentCreate";
import { AgentWorkspace } from "@/pages/agents/AgentWorkspace";
import { AgentRun } from "@/pages/agents/AgentRun";
import { SalesforceReleasesPage } from "@/pages/salesforce-releases";
import { RunsList } from "@/components/organisms/reports/RunsList";
import { Scheduling } from "@/pages/scheduling";
import { Org360Page } from "@/pages/org360";
import { StudioConnectionPage } from "@/pages/agent/agent-studio/pages/StudioConnectionPage";
import { StudioDeploymentPage } from "@/pages/agent/agent-studio/pages/StudioDeploymentPage";
import { StudioDocsPage } from "@/pages/agent/agent-studio/pages/StudioDocsPage";
import { StudioMetadataPage } from "@/pages/agent/agent-studio/pages/StudioMetadataPage";
import { StudioSecurityPage } from "@/pages/agent/agent-studio/pages/StudioSecurityPage";
import { StudioOrgAdminPage } from "@/pages/agent/agent-studio/pages/StudioOrgAdminPage";
import { ReportsPage } from "@/pages/reports";
import { GitPage } from "@/pages/git";

export function TemplatesRoute() {
  return <BrowseSkills />;
}

export function SkillsConnectorsRoute() {
  return <ToolsPage />;
}

export function TemplateWorkspaceRoute() {
  return <TemplateWorkspace />;
}

export function TemplateRunRoute() {
  return <SkillRun />;
}

export function RunsRoute() {
  return <RunsList />;
}

export function ReportsRoute() {
  return <ReportsPage />;
}

export function AgentsRoute() {
  return <AgentsList />;
}

export function AgentCreateRoute() {
  return <AgentCreate />;
}

export function AgentWorkspaceRoute() {
  return <AgentWorkspace />;
}

export function AgentRunRoute() {
  return <AgentRun />;
}

export function SalesforceReleasesRoute() {
  return <SalesforceReleasesPage />;
}

export function Org360Route() {
  return <Org360Page />;
}

export function SchedulingRoute() {
  return <Scheduling />;
}

export function StudioMetadataRoute() {
  return <StudioMetadataPage />;
}

export function StudioDeploymentRoute() {
  return <StudioDeploymentPage />;
}

export function StudioGitRoute() {
  return <GitPage />;
}

export function GitRoute() {
  return <GitPage />;
}

export function StudioSecurityRoute() {
  return <StudioSecurityPage />;
}

export function StudioDocsRoute() {
  return <StudioDocsPage />;
}

export function StudioOrgAdminRoute() {
  return <StudioOrgAdminPage />;
}

export function StudioConnectionRoute() {
  return <StudioConnectionPage />;
}

export default TemplatesRoute;
